import { WireAnalytics } from 'scenes/common/types';

declare global {
  interface Window {
    digitalData: WireAnalytics[];
  }
}
window.digitalData = window.digitalData || [];

const analytics = () => {
  const { digitalData } = window;
  return {
    pushEvent: (event: WireAnalytics) => {
      digitalData.push(event);
    },
  };
};

export default analytics;
